<template>
    <div class="orders-filters">
        <div class="orders-filters__row">
            <OrdersTabs
                class="orders-filters__tabs"
                :filters="filters"
                :tabs="tabs"
                @change="rawFilter"
            />
        </div>
        <div class="orders-filters__row">
            <SearchInput
                class="orders-filters__filter orders-filters__search"
                :placeholder="$t('misc.search')"
                @change="onSearch"
            />

            <DateRangeInput
                class="orders-filters__filter orders-filters__filter--date"
                clearable
                :max-date="new Date()"
                @update:model-value="onDateChange"
            />
            <CustomSelect
                v-if="isInnerWorkspace"
                class="orders-filters__filter select--filter"
                :model-value="filters.customer"
                emit-prop="id"
                placeholder="Customer"
                view-label="name"
                :options="customers"
                :form-value-text="(item) => item.name"
                clearable
                @update:model-value="onChange('customer', $event)"
            >
                <template #default="{ item }">
                    {{ item.name }}
                </template>
            </CustomSelect>
            <CustomSelect
                :disabled="!filters.customer"
                class="orders-filters__filter select--filter"
                :model-value="filters.state"
                emit-prop="id"
                :form-value-text="(item) => item.label[$i18n.locale]"
                :placeholder="filters.customer ? 'State' : 'State: Select customer'"
                :options="states"
                clearable
                @update:model-value="onChange('state', $event)"
            >
                <template #default="{ item }">
                    {{ item.label[$i18n.locale] }}
                </template>
            </CustomSelect>
            <CustomSelect
                class="orders-filters__filter select--filter"
                style="min-width: 100px"
                :model-value="filters.order_type"
                emit-prop="id"
                view-label="name"
                placeholder="Type"
                :options="types"
                clearable
                @update:model-value="onChange('order_type', $event)"
            >
                <template #default="{ item }">
                    {{ item.name }}
                </template>
            </CustomSelect>
            <CustomSelect
                class="orders-filters__filter select--filter"
                :model-value="filters.speaker"
                emit-prop="id"
                placeholder="Speaker"
                :form-value-text="(item) => item.name[$i18n.locale] || item.slug"
                :options="speakers"
                clearable
                with-filter
                @update:model-value="onChange('speaker', $event)"
            >
                <template #default="{ item }">
                    {{ item.name[$i18n.locale] || item.slug }}
                </template>
            </CustomSelect>
            <CustomSelect
                class="orders-filters__filter select--filter"
                :model-value="filters.type_productions"
                emit-prop="id"
                placeholder="Production type"
                view-label="name"
                :options="productionTypes"
                clearable
                @update:model-value="onChange('type_productions', $event)"
            />
        </div>
    </div>
</template>

<script>
import { SearchInput, CustomSelect, DateRangeInput } from '@speechki-frontend/shared/ui/forms';

import OrdersTabs from '../OrdersTabs/OrdersTabs';

import { mapGetters } from 'vuex';

export default {
    name: 'OrdersFilters',
    components: {
        SearchInput,
        CustomSelect,
        DateRangeInput,
        OrdersTabs,
    },

    props: {
        filters: {
            type: Object,
            default: () => {},
        },
        states: {
            type: Array,
            default: () => [],
        },
        customers: {
            type: Array,
            default: () => [],
        },
        productionTypes: {
            type: Array,
            default: () => [],
        },
        speakers: {
            type: Array,
            default: () => [],
        },
        tabs: {
            type: [Array, Object],
            default: () => {},
        },
        types: {
            type: Array,
            default: () => [],
        },
    },

    computed: {
        ...mapGetters('workspaces', ['isInnerWorkspace']),
    },

    methods: {
        onSearch(searchString) {
            this.$emit('search', searchString);
        },
        onDateChange(date) {
            this.$emit('filter', { modified__range: date });
        },
        onChange(field, value) {
            this.$emit('filter', { [field]: value });
        },
        rawFilter(filter) {
            this.$emit('filter', filter);
        },
    },
};
</script>

<style src="./OrdersFilters.scss" lang="scss"></style>
